module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.04822f51.woff2";